/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMap } from '@fortawesome/free-solid-svg-icons';
import { useToast } from '@chakra-ui/react';

import CSS from './search-loads-styles';
import client from '../../../api/api';
import GroupedLoadList from './components/GroupedLoadList';
import filterLoads from './utils/filterLoads';
import findLoadById from './utils/findLoadById';
import LoadsMap from './components/LoadsMap';
import LoadSelected from './components/LoadSelected';
import TruckerList from './components/TruckerList';
import LoadDetail from './components/LoadDetail';
import Alerts from '../../Alerts';
import { getSessionUserData } from '../../../libs/user';
import { DEEP_LINK_ACTIONS, useDeepLinkAction } from '../../../routing';

const GROUP_BY_OPTIONS = [
  { value: 'destination', label: 'Igual destino' },
  { value: 'origin', label: 'Igual origen' },
  { value: 'product', label: 'Igual producto' },
];

// Opción de agrupación seleccionada por defecto al cargar la página
const DEFAULT_GROUP_BY_OPTION = GROUP_BY_OPTIONS.find(option => option.value === 'origin');

const GROUP_BY_SELECT_STYLES = {
  menuPortal: base => ({ ...base, zIndex: 9999 }),
  menu: base => ({
    ...base,
    backgroundColor: '#2b333e',
    color: '#fff',
  }),
  menuList: base => ({
    ...base,
    backgroundColor: '#2b333e',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? '#ffbb0f' : state.isFocused ? '#3a4452' : '#2b333e',
    color: state.isSelected ? '#1c2023' : '#fff',
    cursor: 'pointer',
  }),
};

const SearchLoadsView = () => {
  const toast = useToast();
  const { isPending, payload, consume } = useDeepLinkAction(DEEP_LINK_ACTIONS.TAKE_LOAD);

  const [todayLoadList, setTodayLoadList] = useState('');
  const [tomorrowLoadList, setTomorrowLoadList] = useState('');
  const [nextDaysLoadList, setNextDaysLoadList] = useState('');
  const [loadSelected, setLoadSelected] = useState('');
  const [showMap, setShowMap] = useState(true);
  const [showLoadList, setShowLoadList] = useState(true);
  const [showLoadDetail, setShowLoadDetail] = useState(false);
  const [groupByOption, setGroupByOption] = useState(DEFAULT_GROUP_BY_OPTION);
  const [searchTerm, setSearchTerm] = useState('');
  const [hasFetchedLoads, setHasFetchedLoads] = useState(false);
  const [assignedByUserId, setAssignedByUserId] = useState(null);

  const groupBy = groupByOption ? groupByOption.value : null;

  const filteredTodayLoadList = filterLoads(todayLoadList, searchTerm);
  const filteredTomorrowLoadList = filterLoads(tomorrowLoadList, searchTerm);
  const filteredNextDaysLoadList = filterLoads(nextDaysLoadList, searchTerm);

  const takeLoad = (load, assignedBy = null) => {
    setAssignedByUserId(assignedBy);
    setLoadSelected(load);
    setShowLoadList(false);
  };

  const fetchLoads = async () => {
    try {
      const res = await client.endpoints.carrier.getAvailableLoads(getSessionUserData().data._id);
      if (res.data.today) setTodayLoadList(res.data.today);
      if (res.data.tomorrow) setTomorrowLoadList(res.data.tomorrow);
      if (res.data.others) setNextDaysLoadList(res.data.others);
    } catch (error) {
      const {
        response: { status, data },
      } = error;
      if (status === 429) {
        toast({ title: data, status: 'warning', isClosable: true });
      }
      console.error(error);
    } finally {
      setHasFetchedLoads(true);
    }
  };

  useEffect(() => {
    if (showLoadList) {
      fetchLoads();
    }
  }, [showLoadList]);

  useEffect(() => {
    if (showLoadList && !isPending) {
      setAssignedByUserId(null);
    }
  }, [showLoadList, isPending]);

  // Deep link /load/:loadId → misma acción que "Tomar carga"
  useEffect(() => {
    if (!isPending || !hasFetchedLoads) {
      return;
    }

    const load = findLoadById(payload && payload.loadId, [
      todayLoadList,
      tomorrowLoadList,
      nextDaysLoadList,
    ]);

    if (load) {
      takeLoad(load, payload?.assignedByUserId || null);
    } else {
      toast({
        title: 'No se encontró la carga',
        description: 'La carga no está disponible o ya no podés tomarla.',
        status: 'warning',
        isClosable: true,
      });
    }

    consume();
  }, [
    isPending,
    hasFetchedLoads,
    payload,
    todayLoadList,
    tomorrowLoadList,
    nextDaysLoadList,
    consume,
    toast,
  ]);

  return (
    <>
      <Alerts />
      <CSS.SearchLoadsViewWrap>
        {showLoadList && !isPending ? (
          <CSS.LoadListWrap>
            <CSS.TitleRow>
              <CSS.Title>Elegí una carga</CSS.Title>
              <input
                className="loads-search-input"
                type="text"
                value={searchTerm}
                onChange={event => setSearchTerm(event.target.value)}
                placeholder="Buscar por origen, destino o producto"
              />
              <Select
                className="group-by-select"
                classNamePrefix="group-by"
                options={GROUP_BY_OPTIONS}
                value={groupByOption}
                onChange={setGroupByOption}
                placeholder="Agrupar"
                isClearable
                isSearchable={false}
                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                styles={GROUP_BY_SELECT_STYLES}
              />
            </CSS.TitleRow>
            <CSS.TodayLoadsWrapper>
              <h1>Cargas de hoy</h1>
              {filteredTodayLoadList.length > 0 ? (
                <GroupedLoadList
                  list={filteredTodayLoadList}
                  groupBy={groupBy}
                  setShowLoadList={setShowLoadList}
                  loadSelected={load => takeLoad(load)}
                  setShowLoadDetail={setShowLoadDetail}
                />
              ) : (
                <>
                  {todayLoadList === '' ? (
                    <p className="loading-list">Cargando...</p>
                  ) : searchTerm ? (
                    <p className="empty-list">No hay cargas para hoy que coincidan con la búsqueda...</p>
                  ) : (
                    <p className="empty-list">No hay cargas para hoy en este momento...</p>
                  )}
                </>
              )}
            </CSS.TodayLoadsWrapper>
            <CSS.TomorrowLoadsWrapper>
              <h1>Cargas para mañana</h1>
              {filteredTomorrowLoadList.length > 0 ? (
                <GroupedLoadList
                  list={filteredTomorrowLoadList}
                  groupBy={groupBy}
                  setShowLoadList={setShowLoadList}
                  loadSelected={load => takeLoad(load)}
                  setShowLoadDetail={setShowLoadDetail}
                />
              ) : (
                <>
                  {tomorrowLoadList === '' ? (
                    <p className="loading-list">Cargando...</p>
                  ) : searchTerm ? (
                    <p className="empty-list">
                      No hay cargas para mañana que coincidan con la búsqueda...
                    </p>
                  ) : (
                    <p className="empty-list">No hay cargas para mañana en este momento...</p>
                  )}
                </>
              )}
            </CSS.TomorrowLoadsWrapper>
            <CSS.NextDaysLoadsWrapper>
              <h1>Para mas adelante...</h1>
              {filteredNextDaysLoadList.length > 0 ? (
                <GroupedLoadList
                  list={filteredNextDaysLoadList}
                  groupBy={groupBy}
                  setShowLoadList={setShowLoadList}
                  loadSelected={load => takeLoad(load)}
                  setShowLoadDetail={setShowLoadDetail}
                />
              ) : (
                <>
                  {nextDaysLoadList === '' ? (
                    <p className="loading-list">Cargando...</p>
                  ) : searchTerm ? (
                    <p className="empty-list">
                      No hay cargas para mas adelante que coincidan con la búsqueda...
                    </p>
                  ) : (
                    <p className="empty-list">No hay cargas para mas adelante en este momento...</p>
                  )}
                </>
              )}
            </CSS.NextDaysLoadsWrapper>
          </CSS.LoadListWrap>
        ) : (
          <CSS.TruckerListWrap>
            {isPending && !loadSelected ? (
              <p className="loading-list">Cargando carga...</p>
            ) : loadSelected ? (
              <>
                <CSS.LoadSelectedWrap>
                  <LoadSelected loadSelected={loadSelected} setShowLoadList={setShowLoadList} />
                </CSS.LoadSelectedWrap>
                <TruckerList load={loadSelected} assignedByUserId={assignedByUserId} />
              </>
            ) : (
              ''
            )}
          </CSS.TruckerListWrap>
        )}
        <CSS.MapWrap>
          <CSS.MapIconWrap onClick={() => setShowMap(!showMap)}>
            <span>
              <FontAwesomeIcon icon={faMap} />
            </span>
          </CSS.MapIconWrap>
          {showMap ? <LoadsMap loadSelected={loadSelected} /> : ''}
          <h1>Detalles de la carga</h1>
          {showLoadDetail ? <LoadDetail loadSelected={loadSelected} /> : ''}
        </CSS.MapWrap>
      </CSS.SearchLoadsViewWrap>
    </>
  );
};

export default SearchLoadsView;
